import { useRef } from "react";
import { ConfirmDialog } from "../shared/ConfirmDialog";
import AppToast from "../../../../shared/components/AppToast";
import { ensureCatalogAuth } from "../../../../services/backend/authService";
import { activarSucursal, desactivarSucursal} from "../../../../services/backend/adminService";
import logger from "../../../../shared/utils/logger";

export const EstadoSucursalDialog = ({
  visible,
  sucursal,
  accion = "desactivar",
  onCancel,
  onSave,
}) => {
  const toastRef = useRef(null);

  const isActivar = accion === "activar";
  const header = isActivar ? "Activar Sucursal" : "Desactivar Sucursal";
  const message = isActivar
    ? `¿Realmente desea activar la sucursal "${
        sucursal?.sucursal || sucursal?.almacen || ""
      }"?`
    : `¿Realmente desea desactivar la sucursal "${
        sucursal?.sucursal || sucursal?.almacen || ""
      }"?`;

  const handleConfirm = async () => {
    if (!sucursal?.almacen) {
      toastRef.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Sucursal no seleccionada",
        life: 4000,
      });
      onCancel();
      return;
    }

    try {
      await ensureCatalogAuth();
      if (isActivar) {
        await activarSucursal(sucursal.almacen);
      } else {
        await desactivarSucursal(sucursal.almacen);
      }
      toastRef.current?.show({
        severity: "success",
        summary: "Éxito",
        detail: `Sucursal ${
          isActivar ? "activada" : "desactivada"
        } correctamente`,
        life: 3000,
      });
      onCancel();
      if (onSave) await onSave();
    } catch (err) {
      logger.error("Error al cambiar estado de sucursal:", err);
      toastRef.current?.show({
        severity: "error",
        summary: "Error",
        detail: err.message || "Error al cambiar estado",
        life: 5000,
      });
    }
  };

  return (
    <>
      <AppToast ref={toastRef} />
      <ConfirmDialog
        visible={visible}
        onCancel={onCancel}
        onConfirm={handleConfirm}
        header={header}
        message={message}
      />
    </>
  );
};
